import type {Variants} from 'motion/react';

export const WrapperAnim: Variants = {
    closed: {},
    initial: {},
    open: {}
};

export const IconAnim: Variants = {
    closed: {rotate: 0},
    initial: {rotate: 0},
    open: {rotate: 180}
};

export const BodyAnim: Variants = {
    closed: {height: '0px'},
    initial: {height: '0px'},
    open: {height: 'auto'}
};